////////////////////////////////////////////////////////////////////////////////
// Transcribe Pairs API module
////////////////////////////////////////////////////////////////////////////////

import ApiService from "@/services/api.service";

const transcribe_pairs = {
    endpoint: 'transcribe-pairs',

    all: () => ApiService.getT(transcribe_pairs.endpoint),

    add: (data) => ApiService.postT(transcribe_pairs.endpoint, data),

    del: (pairId) => ApiService.deleteT(`${transcribe_pairs.endpoint}/${pairId}`),
}

export default transcribe_pairs;